<template>
  <div class="mod">
    <div class="hd" @click="go('杭州千岛湖滨江希尔顿度假酒店')">
      <img class="layer" src="./images/img_61290_0_0.png" />
      <span class="location">杭州千岛湖滨江希尔顿度假酒店</span>
      <div class="outer">
        <span class="cny"
          >CNY {{ find("杭州千岛湖滨江希尔顿度假酒店").HotelPrice }}</span
        >
        <span class="cnyNext">起</span>
      </div>
    </div>
    <div class="hd_1" @click="go('深圳蛇口希尔顿南海酒店')">
      <img class="layer_1" src="./images/img_61290_0_1.png" />
      <span class="location_1">深圳蛇口希尔顿南海酒店</span>
      <div class="outer_1">
        <span class="cny_1"
          >CNY {{ find("深圳蛇口希尔顿南海酒店").HotelPrice }}</span
        >
        <span class="cnyNext_1">起</span>
      </div>
    </div>
    <div class="hd_2" @click="go('上海外滩华尔道夫酒店')">
      <img class="layer_2" src="./images/img_61290_0_2.png" />
      <span class="location_2">上海外滩华尔道夫酒店</span>
      <div class="outer_2">
        <span class="cny_2"
          >CNY {{ find("上海外滩华尔道夫酒店").HotelPrice }}</span
        >
        <span class="cnyNext_2">起</span>
      </div>
    </div>
    <div class="hd_3" @click="go('沈阳康莱德酒店')">
      <img class="layer_3" src="./images/img_61290_0_3.png" />
      <span class="location_3">沈阳康莱德酒店</span>
      <div class="outer_3">
        <span class="cny_3"
          >CNY {{ find("沈阳康莱德酒店").HotelPrice }}</span
        >
        <span class="cnyNext_3">起</span>
      </div>
    </div>
    <div class="bgWrap" @click="go('苏州希尔顿酒店')">
      <img class="bg" src="./images/img_61290_0_4.png" />
      <span class="address">苏州希尔顿酒店</span>
      <div class="outer_4">
        <span class="cny_4">CNY {{ find("苏州希尔顿酒店").HotelPrice }}</span>
        <span class="cnyNext_4">起</span>
      </div>
    </div>
    <div class="backgroundWrap" @click="go('成都希尔顿酒店')">
      <img class="background" src="./images/img_61290_0_5.png" />
      <span class="location_4">成都希尔顿酒店</span>
      <div class="block">
        <span class="cny_5">CNY {{ find("成都希尔顿酒店").HotelPrice }}</span>
        <span class="cnyNext_5">起</span>
      </div>
    </div>
    <div class="row">
      <div class="col" @click="go('宁波东钱湖华茂希尔顿酒店')">
        <img class="layer_4" src="./images/img_61290_0_7.png" />
        <span class="address_1">宁波东钱湖华茂希尔顿酒店</span>
        <div class="wrap">
          <span class="cny_6"
            >CNY {{ find("宁波东钱湖华茂希尔顿酒店").HotelPrice }}</span
          >
          <span class="cnyNext_6">起</span>
        </div>
      </div>
      <div class="col_1" @click="go('抚仙湖希尔顿酒店')">
        <img class="layer_5" src="./images/img_61290_0_6.png" />
        <span class="address_2">抚仙湖希尔顿酒店</span>
        <div class="wrap_1">
          <span class="cny_7"
            >CNY {{ find("抚仙湖希尔顿酒店").HotelPrice }}</span
          >
          <span class="cnyNext_7">起</span>
        </div>
      </div>
    </div>
    <div class="hd_4" @click="go('常州新城希尔顿酒店')">
      <img class="layer_6" src="./images/img_61290_0_8.png" />
      <span class="location_5">常州新城希尔顿酒店</span>
      <div class="outer_5">
        <span class="cny_8"
          >CNY {{ find("常州新城希尔顿酒店").HotelPrice }}</span
        >
        <span class="cnyNext_8">起</span>
      </div>
    </div>
    <div class="main">
      <div class="col_2" @click="go('金茂三亚亚龙湾希尔顿大酒店')">
        <img class="layer_7" src="./images/img_61290_0_10.png" />
        <span class="video2">金茂三亚亚龙湾希尔顿大酒店</span>
        <div class="group">
          <span class="cny_9"
            >CNY {{ find("金茂三亚亚龙湾希尔顿大酒店").HotelPrice }}</span
          >
          <span class="cnyNext_9">起</span>
        </div>
      </div>
      <div class="col_3" @click="go('香港港丽酒店')">
        <img class="layer_8" src="./images/img_61290_0_9.png" />
        <span class="video_1">香港港丽酒店</span>
        <div class="group_1">
          <span class="cny_10">CNY {{ find("香港港丽酒店").HotelPrice }}</span>
          <span class="cnyNext_10">起</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      constants: {},
    };
  },
  methods: {
    find(name) {
      let res = this.data.find((item) => name == item.HotelName) || {
        HotelPrice: 0,
      };

      return res;
    },

    go(name) {
      let res = this.data.find((item) => name == item.HotelName) || {
        HotelPrice: 0,
      };

      window.open(res.BookLinkUrl);
    },
  },
  async created() {
    let res = await this.$axios(
      "https://www.hilton.com.cn/Handler/Campaign/CampaignSet.ashx?ActivityId=8"
    );
    this.data = res;
  },
};
</script>
<style src="./index.response.css" scoped/>
